/******************* Django i18n *******************/

// This is just a check to see whether Django jsi18n has been loaded, to give a
// clear error message rather than (or at least before) a bunch of confusing
// errors later on.
if (!window.django) {
    console.error("window.django not defined - ensure Django's jsi18n is loaded before this script")
}


// ModalDialogWrangler handles modal dialogs and trigger buttons set up like this:
//   <button data-modal-trigger="modal-id">...</button>
//   <dialog data-modal="modal-id" class="modal">...</dialog>
//
// The modal dialog itself can also get added in jinja templates like:
// [% call m.modal(
//   modal_id='modal1',
//   modal_title='Wow, a modal'
// ) %]
//   (modal’s contents)
// [% endcall %]
import ModalDialogWrangler from './modal-dialog.js'
const dialogs = document.querySelectorAll('dialog[data-modal]')
if (dialogs) {
  new ModalDialogWrangler(dialogs)
}


// This alert web component can either be included in a jinja template:
//   <base-alert class="alert alert-success">It worked!</base-alert>
// Or created in js:
//   new BaseAlert('It worked!', 'success')
import BaseAlert from './base-alert.js'
customElements.define('base-alert', BaseAlert)

import ReportsHandler from './reports-handler.js'
const reportsContainer = document.querySelector('.reports-container')
if (reportsContainer) {
    new ReportsHandler(reportsContainer)
}
